import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { catchError, throwError } from 'rxjs';
import { AuthInterceptorHelperService } from '../../../../../libs/shared/src/lib/services/auth-interceptor-helper.service';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const platformId = inject(PLATFORM_ID);
  const authInterceptorHelper = inject(AuthInterceptorHelperService);
  const authService = inject(AuthService);

  // Only add auth token in browser environment
  let authReq = req;
  if (isPlatformBrowser(platformId)) {
    const token = localStorage.getItem('session');

    if (token) {
      authReq = req.clone({
        headers: req.headers.set('Authorization', token),
      });
    }
  }

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // Use the shared helper service to handle AUTHORIZATION_EXPIRED
      return authInterceptorHelper.handleAuthorizationExpiredFn(
        error,
        req,
        next,
        authService,
        '/auth/login'
      );
    })
  );
};
